module.exports = __webpack_public_path__ + "img/herrick-membership.90eecf24.png";